export default "__VITE_ASSET__BCHM9wRh__"